module.exports = __webpack_public_path__ + "img/IMG_9033_L_WoodMatted_MockedUp.648f98ea.jpg";